import { FunctionComponent } from 'react';
import { HelpPage } from '../@types/help-page';
import { Newrelic } from '@nrdy-marketing-engine/newrelic';
import HelpPagesIndex from './help-pages-index';
import HotmathHead from './hotmath-head';
import HotmathTitle from './hotmath-title';
import SeoLayout from '@nrdy-marketing-engine/layouts/src/seo-layout';
import AppsBar from '@nrdy-marketing-engine/apps-bar/src/apps-bar';
import type { LinkBlockList } from '@nrdy-marketing-engine/internal-links/@types/schema';
import LinkBlocksContainer from '@nrdy-marketing-engine/internal-links/src/link-blocks-container';

interface HotmathIndexPageProps {
  helpPages: HelpPage[];
  navbarComponent?: FunctionComponent;
  footerComponent?: FunctionComponent;
  browserTimingHeader?: string;
  linkBlocks?: LinkBlockList;
}

export default function HotmathIndexPage({
  helpPages,
  browserTimingHeader,
  linkBlocks,
}: HotmathIndexPageProps) {
  return (
    <>
      <HotmathHead />
      <Newrelic browserTimingHeader={browserTimingHeader} />
      <SeoLayout
        metadata={{
          title: 'Math Homework Help - Answers to Math Problems - Hotmath',
          description:
            'Math homework help. Hotmath explains math textbook homework problems with step-by-step math answers for algebra, geometry, and calculus. Online tutoring available for math help.',
          indexable: true,
        }}
        path="/hotmath"
      >
        <HotmathTitle />
        <HelpPagesIndex helpPages={helpPages} />
        <LinkBlocksContainer linkBlocks={linkBlocks} />
        <AppsBar />
      </SeoLayout>
    </>
  );
}
